import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack, Button, Box} from 'views/components';
import {CancelOutlined} from 'views/icons';
import {Translate, translate} from 'views/module';

import TimelineCard from './TimelineCard';
import moment from 'moment';

const ShiftRequestedCancel = (props) => {
  const {cancellation, caregiverData, setModel, status} = props;
  const timeString = moment(cancellation.createdAt).format('LLL');
  const rejectionReason = cancellation.data.reason || translate('schedule.eventDetail.EventTimelineSection.ShiftRequestedCancel.NoReason');
  const isDeclined = cancellation.adminAction?.status === 'DECLINED';

  const onCancel = async (e) => {
    setModel('ACCEPT_CANCEL_REQUEST');
  };

  const togglePopup = async () => {
    setModel('DECLINE_CANCEL_REQUEST');
  };

  return (
    <Box>
      <TimelineCard
        timeString={timeString}
        icon={CancelOutlined}
        iconColor="#b03621"
        timeBg="#e0e0e0"
        title={<Translate expression='schedule.eventDetail.EventTimelineSection.ShiftRequestedCancel.Title' />}
      >
        <Stack spacing={1}>
          <Typography variant="body2" color="text.secondary">
            <Translate
              expression='schedule.eventDetail.EventTimelineSection.ShiftRequestedCancel.Description'
              substitute={{caregiverName: caregiverData.caregiverDetail.caregiverName}}
            />
          </Typography>
          <Typography fontWeight="bold" fontSize={'14px'}>
            <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftRequestedCancel.Reason' />
          </Typography>
          <Typography color="text.secondary" fontSize={'14px'}>{rejectionReason}</Typography>

          {/* Accept and decline buttons */}
          {
            !isDeclined && status !== 'DEACTIVATED' &&
            <Stack
              direction={{xs: 'column', sm: 'row'}}
              spacing={1}
              sx={{
                '@media (min-width:600px)': {
                  display: 'inline-block',
                },
              }}
            >
              <Button
                onClick={onCancel}
                variant="outlined"
                size='small'
              >
                <Translate expression='generic.Accept' />
              </Button>
              <Button
                onClick={togglePopup}
                variant="outlined"
                size='small'
              >
                <Translate expression='generic.Decline' />
              </Button>
            </Stack>
          }
          {/* Display declined status */}
          {
            isDeclined &&
            <Box
              sx={{
                display: 'inline-block',
                border: '1px solid',
                borderColor: 'error.main',
                color: 'error.main',
                bgcolor: 'rgba(255, 0, 0, 0.05)',
                borderRadius: '4px',
                padding: '1px 12px',
                width: 'fit-content',
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 500,
                }}
              >
                <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftRequestedCancel.RequestDeclined'/>
              </Typography>
            </Box>
          }
        </Stack>
      </TimelineCard>
    </Box>
  );
};

ShiftRequestedCancel.propTypes = {
  cancellation: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    clientRn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    event: PropTypes.shape({
      clientRn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      eventRn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }).isRequired,
    data: PropTypes.shape({
      reason: PropTypes.string,
    }),
    adminAction: PropTypes.shape({
      status: PropTypes.string,
      reason: PropTypes.string,
    }),
  }).isRequired,
  caregiverData: PropTypes.shape({
    caregiverDetail: PropTypes.shape({
      caregiverName: PropTypes.string,
    }),
  }).isRequired,
  setModel: PropTypes.func.isRequired,
  status: PropTypes.string,
};

export default ShiftRequestedCancel;
